import { AppLoaderService } from './../../services/app-loader/app-loader.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  items: MenuItem[];
  images: number[];
  responsiveOptions: { breakpoint: string; numVisible: number; numScroll: number; }[];
  constructor(public router: Router, private loader : AppLoaderService) { }

  ngOnInit(): void {
    this.items = [
      {
        label: 'Atal Login', icon: 'pi pi-fw pi-sign-in', command: () => {
          this.emailLogin();
        }
      },
      {
        label: 'Farmer Login', icon: 'pi pi-fw pi-sign-in', command: () => {
          this.otpLogin();
        }
      },

    ];
    this.images = [1,2,3,4]

    this.responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];
  }

  otpLogin() {
    this.router.navigate(['/phone-login']);
  }

  emailLogin() {
    this.router.navigate(['/login']);
  }
}
